module.exports = __webpack_public_path__ + "img/blood-enter.1f53ea57.png";